import { isoString, systemClock, type Clock } from "../time.js";
import type { Task, TaskPatch } from "./types.js";

/** Apply a patch and bump updated_at. Immutable: returns a new object. */
export function updateTask(task: Task, patch: TaskPatch, now: Clock = systemClock): Task {
  return {
    ...task,
    ...patch,
    id: task.id,
    created_at: task.created_at,
    updated_at: isoString(now()),
  };
}

/** Soft-delete: sets deleted_at without removing the row. */
export function softDeleteTask(task: Task, now: Clock = systemClock): Task {
  const ts = isoString(now());
  return { ...task, deleted_at: ts, updated_at: ts };
}

/** Restore from trash: clears deleted_at. Bumping updated_at is load-bearing so
 *  sync (rev/LWW) propagates the un-delete instead of re-applying a tombstone. */
export function restoreTask(task: Task, now: Clock = systemClock): Task {
  return { ...task, deleted_at: null, updated_at: isoString(now()) };
}
